module.exports = __webpack_public_path__ + "img/guadeloupe.3c26a0a.webp";